'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/object.values/polyfill.js
// module id = 915
// module chunks = 1